import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';

import getContainerStyle from './getContainerStyle';
import getItemSize from './getItemSize';
import getItemStyle from './getItemStyle';

// TODO 230 Remove CSS transitions on everything
const Container = styled.div`
  position: relative;
  transition: none;
`;

const SquareGrid = ({ columnCount, columnGap, items, renderItem, rowGap }) => {
  const [containerElement, setContainerElement] = useState();

  const ref = useCallback(element => {
    if (element != null) {
      setContainerElement(element);
    }
  }, []);

  const itemSize = useMemo(() => {
    if (containerElement == null) {
      return 0;
    }
    return getItemSize(columnCount, columnGap, containerElement.offsetWidth);
  }, [columnCount, columnGap, containerElement]);

  const containerStyle = useMemo(() => {
    if (itemSize === 0) {
      return {};
    }
    return getContainerStyle(columnCount, columnGap, items.length, itemSize, rowGap);
  }, [columnCount, columnGap, items, itemSize, rowGap]);

  const children = useMemo(() => {
    if (itemSize === 0) {
      return [];
    }
    // TODO Don't re-render unchanged items?
    return items.map((item, index) =>
      renderItem({
        item,
        style: getItemStyle(columnCount, columnGap, index, itemSize, rowGap),
      }),
    );
  }, [columnCount, columnGap, itemSize, items, renderItem, rowGap]);

  return (
    <Container ref={ref} style={containerStyle}>
      {children}
    </Container>
  );
};

SquareGrid.defaultProps = {
  columnCount: 1,
  columnGap: 0,
  rowGap: 0,
};

SquareGrid.propTypes = {
  columnCount: PropTypes.number,
  columnGap: PropTypes.number,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  renderItem: PropTypes.func.isRequired,
  rowGap: PropTypes.number,
};

export default SquareGrid;
